import React from 'react';
import './Course.css';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';
import ImageLoader from '../common/ImageLoader/ImageLoader';
import Modal from '../common/Modal/Modal';
import Form  from './Form';


const Course = ({ title, content, image, modal, toggleModalState }) => (
  <div className="post course fade-in">
    <h1 className="text-center mb-5">{title}</h1>
    <div className="post__content text-center">
      {ReactHtmlParser(content)}
    </div>
    <ImageLoader src={image.medium_large || image.full} alt={title} className="course-image" />
    <button
      className="my-btn my-btn--ghost apply-course"
      onClick={toggleModalState}
    >Jelentkezem</button>

    <Modal
      title={`Jelentkezés - ${title}`}
      show={modal}
      toggleModalState={toggleModalState}
      minWidth={700}
    >
      <Form course={title} />
    </Modal>
  </div>
);


Course.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  image: PropTypes.object.isRequired,
  modal: PropTypes.bool.isRequired,
  toggleModalState: PropTypes.func.isRequired
};


export default Course;



// WEBPACK FOOTER //
// ./src/components/Course/Course.js